/**
 * isGatewayAuthFailure — detects whether an error represents a gateway
 * authentication or session-expiry failure.
 *
 * Matches:
 *   - HTTP 401 status (error.status / error.statusCode / error.code)
 *   - Error messages containing "401"
 *   - Error messages containing common auth-failure keywords (case-insensitive)
 *
 * @param {unknown} error
 * @returns {boolean}
 */

const AUTH_KEYWORDS = [
  'unauthorized',
  'token expired',
  'session expired',
  'invalid token',
  'jwt expired',
  'not authenticated',
  'authentication failed',
];

export function isGatewayAuthFailure(error) {
  if (!error) return false;

  if (error.status === 401 || error.statusCode === 401 || error.code === 401) return true;

  const message = (error.message || '').toLowerCase();
  if (message.includes('401')) return true;

  return AUTH_KEYWORDS.some((kw) => message.includes(kw));
}
